import React, { useState } from "react";
import { AlertInterfaces } from "userful-chronos-common-store/dist/notifications";
import Button from "../../button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { Dropdown } from "react-bootstrap";
import UserfulTooltip from "../../Widgets/UserfulTooltip";
import { useTranslation } from "react-i18next";
import UserfulConfirmationDialog from "../UserfulConfirmationDialog";
import Input from "../../Input/Input";
import { useScheduleSelector } from "userful-chronos-common-store/dist/calendar";

interface IProps {
    alerts: AlertInterfaces.AlertConfig[];
    type: "dropdown" | "button";
    onDelete: (id: string) => void;
    addiotnalSecurity?: boolean;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    hideTrigger?: boolean;
}

export default function DeleteNotifications(props: IProps) {
    const { t } = useTranslation();

    const scheduleAllEvents = useScheduleSelector((state) => state.eventsStore.scheduleEvents);

    const isControlled = props.open !== undefined;
    const [showInternal, setShowInternal] = useState(false);
    const show = isControlled ? !!props.open : showInternal;
    const [input, setInput] = useState<string>("");

    if (props.alerts.length === 0) return null;

    const additionalAlerts = props.alerts.length - 1;
    const active = props.alerts.find((alert) => alert.active) ? true : false;
    const scheduled = scheduleAllEvents.find((event) => {
        // console.log(event.schedulableID.type, event.schedulableID.value, props.alerts[0].id.value);
        if (event.schedulableID.type === "ALERT") {
            return props.alerts.find((alert) => alert.id.value === event.schedulableID.value) ? false : true;
        }
    })
        ? true
        : false;
    const addiotnalSecurity = props.addiotnalSecurity || active || scheduled ? true : false;

    const setShowState = (next: boolean) => {
        if (isControlled) {
            props.onOpenChange?.(next);
        } else {
            setShowInternal(next);
        }
    };

    return (
        <>
            {!props.hideTrigger && props.type === "dropdown" && (
                <Dropdown.Item onClick={(e) => setShowState(true)}>
                    <div className="userful-icon-dropdown-menu-icon-container">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </div>
                    <p>{additionalAlerts > 1 ? t("Shared.deleteAll") : t("Shared.delete")}</p>
                </Dropdown.Item>
            )}
            {!props.hideTrigger && props.type === "button" && (
                <UserfulTooltip title={additionalAlerts > 1 ? t("Shared.deleteAll") : t("Shared.delete")}>
                    <Button variant="secondary" iconOnly onClick={() => setShowState(true)}>
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                </UserfulTooltip>
            )}

            <UserfulConfirmationDialog
                show={show}
                icon={{ icon: faCircleExclamation, color: "#D13E2C" }}
                onCancel={() => setShowState(false)}
                title={t("Shared.delete") + " " + additionalAlerts ? t("Shared.alerts") : t("Shared.alert")}
                replaceBody={
                    <>
                        {active && <p style={{ color: "#D13E2C" }}>{t("Notifications.Form.deleteActive")}</p>}
                        {scheduled && <p style={{ color: "#D13E2C" }}>{t("Notifications.Form.deleteScheduled")}</p>}
                        <p>
                            {t("Shared.deleteStart")} <strong>{props.alerts[0].name}</strong>
                            {additionalAlerts > 0 && <strong className="userful-tag">+{additionalAlerts}</strong>}?{" "}
                            {t("Shared.deleteEnd")}
                        </p>
                        {addiotnalSecurity && (
                            <>
                                <Input
                                    filedTitle={t("Shared.deleteConfirmation")}
                                    value={input}
                                    onChange={(e) => {
                                        setInput(e.target.value);
                                    }}
                                />
                            </>
                        )}
                    </>
                }
                replaceFooter={
                    <>
                        <Button variant="secondary" onClick={() => setShowState(false)}>
                            {t("Shared.cancel")}
                        </Button>
                        <Button
                            variant="danger"
                            disabled={addiotnalSecurity && input !== "DELETE"}
                            onClick={() => {
                                props.onDelete(props.alerts[0].id.value);
                                setShowState(false);
                            }}
                        >
                            {additionalAlerts > 0 ? t("Shared.deleteAll") : t("Shared.delete")}
                        </Button>
                    </>
                }
            />
        </>
    );
}
